import React from 'react'

const sliderData =[
    {
        id:1,
        name:"Summer sale",
        image:"https://media.istockphoto.com/photos/beautiful-asian-woman-carrying-colorful-bags-shopping-online-with-picture-id1193750118?k=20&m=1193750118&s=612x612&w=0&h=w46Bjw0TuNVSKHOWtMyVIRfvzZ2JSRP4w7Zm02oqCFE=",
        disc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque harum vero quia rem porro nam praesentium animi ex! Mollitia, iure!"
    },
    {
        id:2,
        name:"Winter sale",
        image:"https://media.istockphoto.com/photos/asian-male-florist-owner-of-small-business-flower-shop-using-digital-picture-id1317277259",
        disc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque harum vero quia rem porro nam praesentium animi ex! Mollitia, iure!"
    }
    ,
    {
        id:3,
        name:"Diwali sale",
        image:"https://media.istockphoto.com/photos/young-attractive-beautiful-female-entrepreneur-fund-borrower-crazy-picture-id1319565513",
        disc:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque harum vero quia rem porro nam praesentium animi ex! Mollitia, iure!"
    }
]

export default sliderData;